<template>
  <div class="ReflexTuner">
    <div class="row container justify-content-center p-2 text-center">
      <div class="col-sm-5">
        <div class="row center">
          <div style="width: 16%;"></div>
          <div style="width: 42%;">Akkadian</div>
          <div style="width: 42%;">Aramaic</div>
        </div>
        <div class="row center">
          <div style="width: 16%;">א</div>
          <div style="width: 42%;"><input v-model="Akkadian.ʔ" @change="onChange"></div>
          <div style="width: 42%;"><input v-model="Aramaic.ʔ" @change="onChange"></div>
        </div>
        <div class="row center">
          <div style="width: 16%;">ב</div>
          <div style="width: 42%;"><input v-model="Akkadian.b" @change="onChange"></div>
          <div style="width: 42%;"><input v-model="Aramaic.b" @change="onChange"></div>
        </div>
        <div class="row center">
          <div style="width: 16%;">ג</div>
          <div style="width: 42%;"><input v-model="Akkadian.g" @change="onChange"></div>
          <div style="width: 42%;"><input v-model="Aramaic.g" @change="onChange"></div>
        </div>
        <div class="row center">
          <div style="width: 16%;">ד</div>
          <div style="width: 42%;"><input v-model="Akkadian.d" @change="onChange"></div>
          <div style="width: 42%;"><input v-model="Aramaic.d" @change="onChange"></div>
        </div>
        <div class="row center">
          <div style="width: 16%;">ה</div>
          <div style="width: 42%;"><input v-model="Akkadian.h" @change="onChange"></div>
          <div style="width: 42%;"><input v-model="Aramaic.h" @change="onChange"></div>
        </div>
        <div class="row center">
          <div style="width: 16%;">ו</div>
          <div style="width: 42%;"><input v-model="Akkadian.w" @change="onChange"></div>
          <div style="width: 42%;"><input v-model="Aramaic.w" @change="onChange"></div>
        </div>
        <div class="row center">
          <div style="width: 16%;">ז</div>
          <div style="width: 42%;"><input v-model="Akkadian.z" @change="onChange"></div>
          <div style="width: 42%;"><input v-model="Aramaic.z" @change="onChange"></div>
        </div>
        <div class="row center">
          <div style="width: 16%;">ח</div>
          <div style="width: 42%;"><input v-model="Akkadian.ḥ" @change="onChange"></div>
          <div style="width: 42%;"><input v-model="Aramaic.ḥ" @change="onChange"></div>
        </div>
        <div class="row center">
          <div style="width: 16%;">ט</div>
          <div style="width: 42%;"><input v-model="Akkadian.ṭ" @change="onChange"></div>
          <div style="width: 42%;"><input v-model="Aramaic.ṭ" @change="onChange"></div>
        </div>
        <div class="row center">
          <div style="width: 16%;">י</div>
          <div style="width: 42%;"><input v-model="Akkadian.y" @change="onChange"></div>
          <div style="width: 42%;"><input v-model="Aramaic.y" @change="onChange"></div>
        </div>
        <div class="row center">
          <div style="width: 16%;">כ/ך</div>
          <div style="width: 42%;"><input v-model="Akkadian.k" @change="onChange"></div>
          <div style="width: 42%;"><input v-model="Aramaic.k" @change="onChange"></div>
        </div>
      </div>
      <div class="col-sm-1"></div>
      <div class="col-sm-5">
        <div class="row center">
          <div style="width: 16%;"></div>
          <div style="width: 42%;">Akkadian</div>
          <div style="width: 42%;">Aramaic</div>
        </div>
        <div class="row center">
          <div style="width: 16%;">ל</div>
          <div style="width: 42%;"><input v-model="Akkadian.l" @change="onChange"></div>
          <div style="width: 42%;"><input v-model="Aramaic.l" @change="onChange"></div>
        </div>
        <div class="row center">
          <div style="width: 16%;">מ/ם</div>
          <div style="width: 42%;"><input v-model="Akkadian.m" @change="onChange"></div>
          <div style="width: 42%;"><input v-model="Aramaic.m" @change="onChange"></div>
        </div>
        <div class="row center">
          <div style="width: 16%;">נ/ן</div>
          <div style="width: 42%;"><input v-model="Akkadian.n" @change="onChange"></div>
          <div style="width: 42%;"><input v-model="Aramaic.n" @change="onChange"></div>
        </div>
        <div class="row center">
          <div style="width: 16%;">ס</div>
          <div style="width: 42%;"><input v-model="Akkadian.s" @change="onChange"></div>
          <div style="width: 42%;"><input v-model="Aramaic.s" @change="onChange"></div>
        </div>
        <div class="row center">
          <div style="width: 16%;">ע</div>
          <div style="width: 42%;"><input v-model="Akkadian.ʕ" @change="onChange"></div>
          <div style="width: 42%;"><input v-model="Aramaic.ʕ" @change="onChange"></div>
        </div>
        <div class="row center">
          <div style="width: 16%;">פ/ף</div>
          <div style="width: 42%;"><input v-model="Akkadian.p" @change="onChange"></div>
          <div style="width: 42%;"><input v-model="Aramaic.p" @change="onChange"></div>
        </div>
        <div class="row center">
          <div style="width: 16%;">צ/ץ</div>
          <div style="width: 42%;"><input v-model="Akkadian.ṣ" @change="onChange"></div>
          <div style="width: 42%;"><input v-model="Aramaic.ṣ" @change="onChange"></div>
        </div>
        <div class="row center">
          <div style="width: 16%;">ק</div>
          <div style="width: 42%;"><input v-model="Akkadian.q" @change="onChange"></div>
          <div style="width: 42%;"><input v-model="Aramaic.q" @change="onChange"></div>
        </div>
        <div class="row center">
          <div style="width: 16%;">ר</div>
          <div style="width: 42%;"><input v-model="Akkadian.r" @change="onChange"></div>
          <div style="width: 42%;"><input v-model="Aramaic.r" @change="onChange"></div>
        </div>
        <div class="row center">
          <div style="width: 16%;">ש</div>
          <div style="width: 42%;"><input v-model="Akkadian.š" @change="onChange"></div>
          <div style="width: 42%;"><input v-model="Aramaic.š" @change="onChange"></div>
        </div>
        <div class="row center">
          <div style="width: 16%;">ת</div>
          <div style="width: 42%;"><input v-model="Akkadian.t" @change="onChange"></div>
          <div style="width: 42%;"><input v-model="Aramaic.t" @change="onChange"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { ref } from 'vue';
// import axios from 'axios';

export default {
  name: 'ReflexTuner',
  props: {
  },
  data() {
    return {
      Akkadian: {
        'ʔ': 'ʔ,h,_',
        'b': 'b,p',
        'g': 'g,q',
        'd': 'd,z',
        'h': 'ʔ,h,_',
        'w': 'y,w,_',
        'z': 'd,z',
        'ḥ': 'ʔ,h,_',
        'ṭ': 'ṭ,t',
        'y': 'ʔ,w,y,_',
        'k': 'h,k,q',
        'l': 'l',
        'm': 'm',
        'n': 'n',
        's': 's,š',
        'ʕ': 'ʔ,h,_',
        'p': 'b,p',
        'ṣ': 'ṣ,z',
        'q': 'g,k,q',
        'r': 'r',
        'š': 's,š',
        't': 'ṭ,t',
      },
      Aramaic: {
        'ʔ': 'ʔ,h,y',
        'b': 'b',
        'g': 'g',
        'd': 'd,z',
        'h': 'ʔ,h',
        'w': 'w',
        'z': 'd,z',
        'ḥ': 'ḥ,ʕ',
        'ṭ': 'ṭ',
        'y': 'ʔ,y',
        'k': 'k',
        'l': 'l',
        'm': 'm',
        'n': 'n',
        's': 's,š',
        'ʕ': 'ḥ,ʕ,ṣ',
        'p': 'p',
        'ṣ': 'ṣ,ʕ',
        'q': 'q',
        'r': 'r',
        'š': 's,š,t',
        't': 't',
      }
    }
  },
  mounted() {
  },
  methods: {
    onChange() {
      if (event) {
        this.$emit('reflexChanged', event.target.textContent);
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.ReflexTuner {
  background: white;
  color: black;
}
.ReflexTuner input {
  width: 100%;
}
</style>
